import _ from "lodash";

/**
 * 预约管理查询
 */
export interface SubscribeManageInfo {
  /**
   * 手机号
   */
  phone?: string;
  /**
   * 会员号
   */
  user_code?: string;
  /**
   * 姓名
   */
  user_name?: string;
  /**
   * 会员等级 3奕尊 4奕尚
   */
  level?: number;
  /**
   * 预约项目id
   */
  option_id?: number;
  /**
   * 预约状态id
   */
  status?: number[];
  /**
   * 更新状态id
   */
  update_status?: number;
  /**
   * 预约时间(start_date、end_date)
   */
  time_range?: string[];
  /**
   * 预约时间段
   */
  number?: string;
}

/**
 * 预约管理查询表单默认值
 */
export const defaultInfo: SubscribeManageInfo = {
  phone: '',
  user_code: '',
  user_name: '',
  level: null,
  option_id: null,
  status: [],
  update_status: null,
  time_range: [],
  // time_range: [dayjs().format(FULL_DATE), dayjs().format(FULL_DATE)],
  number: '',
};

export enum SUBSCRIBE_STATUS {
  /**
   * 未审核
   */
  UNREVIEWED = 1,
  /**
   * 已通过
   */
  PASSED = 2,
  /**
   * 已拒绝
   */
  REFUSED = 3,
  /**
   * 已取消
   */
  CANCELED = 4,
  /**
   * 已核销
   */
  USED = 6,
}

/**
 * 预约服务状态
 */
export const SubscribeServiceStatus = {
  [SUBSCRIBE_STATUS.UNREVIEWED]: '未审核',
  [SUBSCRIBE_STATUS.PASSED]: '已通过',
  [SUBSCRIBE_STATUS.REFUSED]: '已拒绝',
  [SUBSCRIBE_STATUS.CANCELED]: '已取消',
  [SUBSCRIBE_STATUS.USED]: '已核销',
};

/**
 * 操作类型type
 */
export enum OPERATION_TYPE {
  /**
   * 通过
   */
  PASS = 2,
  /**
   * 拒绝
   */
  REFUSE = 3,
  /**
   * 取消
   */
  CANCEL = 4,
}

/**
 * 操作类型
 */
export const Operation = {
  [OPERATION_TYPE.PASS]: '通过',
  [OPERATION_TYPE.REFUSE]: '拒绝',
  [OPERATION_TYPE.CANCEL]: '取消',
};

export const transformFormData = (values) => Object.assign({}, _.omit(values, 'time_range'), {
  start_at:
    (values?.time_range && values?.time_range?.length === 2 && values?.time_range[0]) || '',
  end_at:
    (values?.time_range && values?.time_range?.length === 2 && values?.time_range[1]) || '',
  status: values?.status?.length ? values?.status?.join() : '',
})
